import React from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { useForm } from 'react-hook-form';
import { Grid } from '@material-ui/core';
import { FontAwesomeIcon } from '@vr/lib';
import {
  ContainerButton,
  Title as TitleDefault,
} from '~/components/forms/common';
import { Button, TextField } from '~/elements';
import getErrorMsg from '~/helpers/errorMessages';
import devices from '~/styles/devices';

const Container = styled.div`
  max-width: 710px;
  margin: 0 auto;
`;
const ChangePassword = styled.form``;
const Subtitle = styled.h3`
  font-size: 1rem;
  color: ${({ theme }) => theme.colors.white};
  font-weight: 600;
  margin: 45px 0 5px;
`;
const Actions = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  button {
    width: 100%;
  }
`;
const HintTitle = styled.p`
  color: ${({ theme }) => theme.colors.secondary};
  margin: 32px 0 5px;
  font-size: 12px;
`;
const HintDescription = styled.p`
  color: ${({ theme }) => theme.colors.white};
  margin-bottom: 39px;
  font-size: 12px;
`;
const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 36px;

  @media (min-width: ${devices.tablet}) {
    justify-content: center;
  }
`;
const BackIcon = styled(FontAwesomeIcon)`
  display: block;
  color: ${({ theme }) => theme.colors.white};
  margin-right: 17px;
  font-size: 20px;
  cursor: pointer;
  width: 21px;
  height: 21px;

  @media (min-width: ${devices.tablet}) {
    display: none;
  }
`;
const Title = styled(TitleDefault)`
  margin-bottom: 0;
`;

export default function AccessDataForm({ onSubmit, email }) {
  const { handleSubmit, errors, formState, ...formControl } = useForm({
    mode: 'onChange',
  });
  const history = useHistory();

  return (
    <Container>
      <TitleContainer>
        <BackIcon
          aria-label="voltar"
          onClick={() => history.goBack()}
          icon={['fas', 'chevron-left']}
        />
        <Title color="white">Dados de acesso</Title>
      </TitleContainer>
      <Grid container spacing={4}>
        <Grid item xs={12} sm={6}>
          <TextField
            ariaLabel="email"
            value={email}
            fullWidth
            disabled
            label="Seu e-mail"
            name="email"
            type="email"
          />
        </Grid>
      </Grid>
      <ChangePassword onSubmit={handleSubmit(onSubmit)}>
        <Subtitle>Alterar senha</Subtitle>
        <Grid container spacing={4}>
          <Grid item xs={12} sm={6}>
            <TextField
              ariaLabel="senha atual"
              fullWidth
              label="Digite sua senha atual *"
              name="currentPassword"
              rules={{
                required: true,
                minLength: 8,
              }}
              type="password"
              formControl={formControl}
              error={!!errors.currentPassword}
              caption={getErrorMsg(errors, 'currentPassword')}
            />
          </Grid>
        </Grid>
        <Grid container spacing={4}>
          <Grid item xs={12} sm={6}>
            <TextField
              ariaLabel="nova senha"
              fullWidth
              label="Digite sua nova senha *"
              name="newPassword"
              rules={{
                required: true,
                minLength: 8,
              }}
              type="password"
              formControl={formControl}
              error={!!errors.newPassword}
              caption={getErrorMsg(errors, 'newPassword')}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              ariaLabel="confirmação da nova senha"
              fullWidth
              name="confirmNewPassword"
              label="Confirme sua nova senha *"
              type="password"
              rules={{
                required: true,
                validate: val => val === formControl.getValues('newPassword'),
                minLength: 8,
              }}
              formControl={formControl}
              error={!!errors.confirmNewPassword}
              caption={getErrorMsg(errors, 'confirmNewPassword')}
            />
          </Grid>
        </Grid>
        <HintTitle>Dica de senha</HintTitle>
        <HintDescription>
          Crie uma senha com no minimo 8 caracteres. Evite senhas fáceis de
          adivinhar.
        </HintDescription>
        <Actions>
          <Button
            ariaLabel="atualizar dados"
            label="Atualizar dados"
            type="submit"
            variant="contained"
            disabled={!formState.isValid}
          />
          <ContainerButton>
            <Button
              ariaLabel="cancelar"
              label="Cancelar"
              onClick={() => history.goBack()}
              variant="transparent"
            />
          </ContainerButton>
        </Actions>
      </ChangePassword>
    </Container>
  );
}

AccessDataForm.propTypes = {
  onSubmit: PropTypes.func,
  email: PropTypes.string.isRequired,
};
